import React from "react";

export default function LineupBoxFootball({ home, away }) {
  return (
    <div className="football_lineup_box">
      <div className="ft_lineup_columns">
        <ul className="ft_list_lineup">
          <li>
            <div className="teams_wrap">
              <div className="teams-name">
                <span className="lin_name">{home}</span>
              </div>
            </div>
          </li>
        </ul>
        <ul className="ft_list_lineup">
          <li>
            <div className="teams_wrap">
              <div className="teams-name">
                <span className="lin_name">{away}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
